export default {
    //获取新闻内容
    getContent: "client/market/skipAuth/mobile/websiteNew/details",
};
